export default {
    ultimoCodigoContableCaja: '1.1.1.01.01',
    ultimoCodigoContableNumCaja: 0,
    ultimoCodigoContableBanco: '1.1.1.02.01',
    ultimoCodigoContableNumBanco: 0,
    codigosContables: [],
    codigosContablesFiltros: [],
}